export enum Destination {
  ALL_WEBSITES = -2,
  EVERYTHING = -1,
  OTT = 0,
}

export enum DestinationDescription {
  ALL_MOBILE_APPS = 'All mobile apps',
  ALL_WEBSITES = 'All websites',
  EVERYTHING = 'Everything',
  OTT = 'OTT',
  CUSTOM = 'Custom',
}
